import Emitter from "es6-event-emitter";

import AlbSlide from "./albSlide";

export default class AlbPage extends Emitter {
  appState = null;
  pages = null;
  options = null;
  pageNumber = null;
  albSlides = [];

  constructor(appState, pages, pageNumber, options) {
    super();
    this.appState = appState;
    this.pages = pages;
    this.pageNumber = pageNumber;
    this.options = options;
  }

  render() {
    const promise = new Promise((resolve, reject) => {
      Promise.all(
        this.pages.map((page, pageIndex) => {
          return this.createPage(page, pageIndex);
        })
      ).then((result) => {
        result.forEach((pageSlides) => {
          this.albSlides.push(pageSlides);
        });
        if (this.getAllAlbSlides().length === 0) {
          reject(true);
        } else {
          resolve(true);
        }
      });
    });
    return promise;
  }

  getAllAlbSlides() {
    const result = [];
    this.albSlides.forEach((slide) => {
      slide.forEach((s) => {
        result.push(s);
      });
    });
    return Array.prototype.slice.call(result);
  }

  createPage(page, pageIndex) {
    const promise = new Promise((resolve) => {
      const albSlides = [];
      // const slides = [];
      if (page) {
        Promise.all(
          page.content.map((content, index) => {
            const albSide = new AlbSlide(
              this.appState,
              content,
              this.pageNumber,
              pageIndex,
              index,
              this.options
            );
            albSide.on("albSlide:hideExtraButton", () => {
              this.trigger("albPage:hideExtraButton");
            });
            albSide.on("albSlide:showExtraButton", () => {
              this.trigger("albPage:showExtraButton");
            });
            albSlides.push(albSide);
            return albSide.render();
          })
        ).then(() => {
          resolve(albSlides);
        });
      } else {
        resolve(albSlides);
      }
    });
    return promise;
  }

  onAddedToAlb() {
    this.albSlides.forEach((slide) => {
      slide.onAddedToAlb();
    });
  }
}



// WEBPACK FOOTER //
// ./src/common/components/articleLightbox/albPage.js